<app-admin-header [header]="header" [breadcrumbs]="breadcrumbs" [compact]="true"></app-admin-header>

<div class="container-fluid ntf-page">
  <div class="ntf-layout">
    <!-- Category sidebar -->
    <aside class="ntf-card ntf-sidebar">
      <h2 class="ntf-sidebar-title">{{ "Notification Categories" | translator }}</h2>
      <button
        *ngFor="let category of categoryFilters"
        class="ntf-category"
        [class.active]="currentCategory == category"
        (click)="changeCurrentFilter(category)"
      >
        <i class="{{ getCategoryIcon(category) }}"></i>
        <span>{{ getCategoryArabics(category) }}</span>
      </button>
    </aside>

    <section class="ntf-card ntf-main">
      <!-- Toolbar: read tabs, search, mark all -->
      <div class="ntf-toolbar">
        <div class="ntf-tabs">
          <button class="ntf-tab" [class.active]="readFilter == 'all'" (click)="changeReadFilter('all')">
            {{ "ALL" | translator }}
          </button>
          <button class="ntf-tab" [class.active]="readFilter == 'unread'" (click)="changeReadFilter('unread')">
            {{ "Unread" | translator }} ({{ unreadCount }})
          </button>
        </div>
        <div class="ntf-search">
          <i class="pi pi-search"></i>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            placeholder="{{ 'Search notifications' | translator }}"
          />
        </div>
        <button class="ntf-btn ntf-btn-outline ntf-mark-all" [disabled]="!hasUnseenNotifications" (click)="markAllSeen()">
          {{ "markAllRead" | translator }}
          <i class="pi pi-check-circle"></i>
        </button>
      </div>

      <!-- Loading skeleton shaped like the notification rows -->
      <div class="ntf-list ntf-skeleton" *ngIf="skelition" aria-busy="true">
        <span class="ntf-skel ntf-skel-label"></span>
        <div class="ntf-group">
          <div class="ntf-row" *ngFor="let _ of skeletonRows">
            <span class="ntf-skel ntf-skel-icon"></span>
            <div class="ntf-body">
              <span class="ntf-skel ntf-skel-title"></span>
              <span class="ntf-skel ntf-skel-text"></span>
              <span class="ntf-skel ntf-skel-tag"></span>
            </div>
            <span class="ntf-skel ntf-skel-time"></span>
          </div>
        </div>
      </div>
      <app-no-data *ngIf="!skelition && listNotifications.length == 0"></app-no-data>

      <!-- Rows grouped by day -->
      <div class="ntf-list" *ngIf="!skelition && listNotifications.length > 0">
        <ng-container *ngFor="let group of pagedGroups">
          <h3 class="ntf-group-label">{{ group.label }}</h3>
          <div class="ntf-group">
            <div
              *ngFor="let notification of group.items; trackBy: trackByNotificationId"
              class="ntf-row"
              [class.unread]="!isSeen(notification)"
              role="button"
              (click)="openNotification(notification)"
            >
              <div class="ntf-icon">
                <i class="{{ getNotificationIcon(notification) }}"></i>
              </div>

              <div class="ntf-body">
                <div class="ntf-title-line">
                  <span class="ntf-dot" [class.read]="isSeen(notification)"></span>
                  <span class="ntf-title">{{ notification.title || notification.message }}</span>
                  <span *ngIf="!isSeen(notification)" class="ntf-badge">{{ "Unread" | translator }}</span>
                </div>
                <p class="ntf-message">
                  {{ notification.message }}<ng-container *ngIf="notification.name">: {{ notification.name }}</ng-container>
                </p>
                <span class="ntf-category-tag">
                  <i class="{{ getCategoryIcon(notification.category) }}"></i>
                  {{ getCategoryArabics(notification.category) }}
                </span>
              </div>

              <button
                *ngIf="getActionLabel(notification) as actionLabel"
                class="ntf-btn ntf-btn-outline ntf-action"
                (click)="$event.stopPropagation(); openNotification(notification)"
              >
                {{ actionLabel }}
              </button>

              <span class="ntf-time">{{ getTimeLabel(notification.createdAt) }}</span>

              <button class="ntf-kebab" (click)="openRowMenu(rowMenu, $event, notification)">
                <i class="pi pi-ellipsis-v"></i>
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Pagination -->
      <div class="ntf-pagination" *ngIf="!skelition && listNotifications.length > 0">
        <span class="ntf-page-info">
          {{ "Showing" | translator }} {{ pageStart }} – {{ pageEnd }} {{ "of" | translator }}
          {{ listNotifications.length }}{{ hasMore ? "+" : "" }} {{ "notification items" | translator }}
        </span>
        <div class="ntf-pages">
          <button class="ntf-page-btn" [disabled]="currentPage == 1" (click)="goToPage(currentPage - 1)">
            <i class="pi pi-angle-right"></i>
          </button>
          <button
            *ngFor="let page of pageNumbers"
            class="ntf-page-btn"
            [class.active]="page == currentPage"
            [disabled]="page == -1"
            (click)="goToPage(page)"
          >
            {{ page == -1 ? "…" : page }}
          </button>
          <button
            class="ntf-page-btn"
            [disabled]="(currentPage == totalPages && !hasMore) || loadingMore"
            (click)="goToPage(currentPage + 1)"
          >
            <i class="pi pi-angle-left"></i>
          </button>
        </div>
      </div>
    </section>
  </div>
</div>

<p-menu #rowMenu [model]="activeRowMenu" [popup]="true" appendTo="body" styleClass="ntf-row-menu"></p-menu>
<app-footer></app-footer>
